export default "__VITE_ASSET__DAj7sgxj__"